module.exports = __webpack_public_path__ + "img/whatsapp.774352de.png";